import { enUS } from "@mui/material/locale";
import enMessages from "../locales/en_US.json";

const FrLang = {
  messages: {
    ...enMessages,
  },
  muiLocale: enUS,
  locale: "en-US",
};
export default FrLang;
